import Repository from './repository';

const resource = '/cfm';

export default {
	getConstants() {
		return Repository.getWithAuth(`${resource}/constants`);
	},

	getGlobalSettings() {
		return Repository.getWithAuth(`${resource}/global_settings`);
	},

	createGlobalSettings(payload) {
		return Repository.postWithAuth(
			`${resource}/global_settings`,
			payload,
			{},
			{ noCache: true }
		);
	},
	checksPaginate(payload) {
		return Repository.postWithAuth(
			`${resource}/checks/find`,
			payload,
			{},
			{ noCache: true }
		);
	},
	riskLevelsPaginate(payload) {
		return Repository.postWithAuth(
			`${resource}/risk_levels/find`,
			payload,
			{},
			{ noCache: true }
		);
	},

	createTheme(payload) {
		return Repository.postWithAuth(
			`${resource}/save_theme`,
			payload,
			{},
			{ noCache: true }
		);
	},

	getTheme(payload) {
		return Repository.postWithAuth(`${resource}/get_theme`, payload);
	},
	updateCheck(checkId, payload) {
		return Repository.postWithAuth(
			`${resource}/check/${checkId}`,
			payload,
			{},
			{ noCache: true }
		);
	},
	createCheck(payload) {
		return Repository.postWithAuth(
			`${resource}/check`,
			payload,
			{},
			{ noCache: true }
		);
	},

	deleteCheck(checkId) {
		return Repository.deleteWithAuth(`${resource}/check/${checkId}`);
	},

	getChecksByMerchantID() {
		return Repository.getWithAuth(`${resource}/checks`);
	},

	getRiskLevelsByMerchantID() {
		return Repository.getWithAuth(`${resource}/risk_levels`);
	},

	getRiskLevelByID(id) {
		return Repository.getWithAuth(`${resource}/risk_levels/${id}`);
	},

	createRiskLevel(payload) {
		return Repository.postWithAuth(
			`${resource}/risk_level`,
			payload,
			{},
			{ noCache: true }
		);
	},

	upateRiskLevel(id, payload) {
		return Repository.postWithAuth(`${resource}/risk_levels/${id}`, payload);
	},

	deleteRiskLevel(id) {
		return Repository.deleteWithAuth(`${resource}/risk_levels/${id}`);
	},

	findRiskLevelRelations() {
		return Repository.getWithAuth(`${resource}/risk_level_relations`);
	},

	getGlobalDocuments() {
		return Repository.getWithAuth(`${resource}/global_documents`);
	},

	createGlobalDocuments(payload) {
		return Repository.postWithAuth(
			`${resource}/global_documents/create`,
			payload,
			{},
			{ noCache: true }
		);
	},

	updateGlobalDocuments(payload) {
		return Repository.postWithAuth(
			`${resource}/global_documents/update`,
			payload,
			{},
			{ noCache: true }
		);
	},

	resetGlobalDocuments() {
		return Repository.postWithAuth(
			`${resource}/global_documents/reset`,
			{},
			{},
			{ noCache: true }
		);
	},

	resetSystem() {
		return Repository.postWithAuth(
			`${resource}/global_documents/reset/system`,
			{},
			{},
			{ noCache: true }
		);
	},
	createQuestionsExtractionJob(formData) {
		return Repository.postWithAuth(
			`${resource}/questions_extraction/create`,
			formData,
			{ 'Content-Type': 'multipart/form-data' },
			{ noCache: true }
		);
	},

	getActiveQuestionsExtractionJob() {
		return Repository.getWithAuth(
			`${resource}/questions_extraction/active`,
			{},
			{},
			{ noCache: true }
		);
	},

	deleteQuestionsExtractionJob(jobID) {
		return Repository.deleteWithAuth(
			`${resource}/questions_extraction/${jobID}`,
			{},
			{},
			{ noCache: true }
		);
	},

	cancelQuestionsExtractionJob(jobID) {
		return Repository.postWithAuth(
			`${resource}/questions_extraction/${jobID}/cancel`,
			{},
			{},
			{ noCache: true }
		);
	},

	retryQuestionsExtractionJob(jobID) {
		return Repository.postWithAuth(
			`${resource}/questions_extraction/${jobID}/retry`,
			{},
			{},
			{ noCache: true }
		);
	},
};
